import { formatBalance as sharedFormatBalance } from "@cede/utils";
import Decimal from "decimal.js";

export const formatBalance = (value: string | number, digits = 2) => {
  const roundForFiat = digits <= 2;
  const maxDigits = digits > 2 ? Math.max(4, digits + 2) : undefined;

  return sharedFormatBalance(value, {
    roundForFiat,
    maxDigits,
    showSmallDigits: !roundForFiat,
  });
};

export const safeDecimal = (value?: string | number | null, fallback: Decimal.Value = "0") => {
  try {
    if (value === undefined || value === null || value === "") {
      return new Decimal(fallback);
    }
    const decimal = new Decimal(value);
    return decimal.isFinite() ? decimal : new Decimal(fallback);
  } catch {
    return new Decimal(fallback);
  }
};

export const parseDecimalInput = (value?: string) => {
  if (!value || value.trim() === "") {
    return null;
  }

  try {
    const decimal = new Decimal(value);
    return decimal.isFinite() ? decimal : null;
  } catch {
    return null;
  }
};
